export default "__VITE_ASSET__4b57c457__"